// extracted by mini-css-extract-plugin
export default {"root":"Logo--root--3lrec","img":"Logo--img--3n0It"};